import axios from 'axios'

// Axios instance mirroring authService configuration
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://127.0.0.1:5000',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers['Authentication-Token'] = token
    }
    return config
  },
  (error) => Promise.reject(error)
)

export const getPrompts = async (userId) => {
  const res = await api.get(`/api/reflections/${userId}/prompts`)
  return res.data
}

export const getHistory = async (userId) => {
  const res = await api.get(`/api/reflections/${userId}/history`)
  return res.data
}

export const createReflection = async (userId, payload) => {
  const res = await api.post(`/api/reflections/${userId}`, payload)
  return res.data
}

export const updateReflection = async (reflectionId, payload) => {
  const res = await api.put(`/api/reflections/${reflectionId}/update`, payload)
  return res.data
}

export const deleteReflection = async (reflectionId) => {
  const res = await api.delete(`/api/reflections/${reflectionId}/delete`)
  return res.data
}

export default {
  getPrompts,
  getHistory,
  createReflection,
  updateReflection,
  deleteReflection
}


